import React from 'react';

import InputLabel from 'components/inputfields/InputLabel';
import InputTextField from 'components/inputfields/InputTextField';
import AiFieldVerdict from '../AiFieldVerdict';

import IProduct from 'models/product';
import ThreeWaySwitch from 'components/inputfields/ThreeWaySwitch';
import { useProductValidations } from '../validation-context/ProductValidationContext';

interface IShortSalesDataProps {
  readOnly?: boolean;
  approve?: boolean;
  state: IProduct;
  setState: (state: IProduct) => void;
}

export const SHORT_SALES_DESCRIPTION_MAX_LENGTH = 155;

const getShortSalesDescriptionLength = (value?: string): number => value?.length ?? 0;

export const checkShortSalesDescriptionError = (value?: string): string => {
  if (getShortSalesDescriptionLength(value) > SHORT_SALES_DESCRIPTION_MAX_LENGTH) {
    return 'Kort säljande beskrivning får innehålla högst 155 tecken';
  }
  return '';
};

const ShortSalesDescription = ({ readOnly, approve, state, setState }: IShortSalesDataProps) => {
  const { requiredFields } = useProductValidations();
  // Derive error directly from state instead of keeping local useState.
  // This ensures the inline error and red highlight are immediately shown on initial load
  // if an existing product already exceeds 155 characters, and stays in sync with SubmitButton.
  const error = checkShortSalesDescriptionError(state?.shortSalesDescription);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    const value = event.target.value;

    setState({ ...state, [name]: value });
  };

  return (
    <div style={{ width: '100%' }}>
      <InputLabel
        required={!!requiredFields.shortSalesDescription}
        heading="Kort säljande beskrivning"
        text="Här skriver du en mening som säljer och beskriver produkten."
      />
      <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
        <div style={{ flexGrow: 1 }}>
          <InputTextField
            readOnly={readOnly}
            state={state}
            setState={setState}
            inputName="shortSalesDescription"
            hideAiVerdict
            value={state.shortSalesDescription}
            placeholder='Skriv en mening på max 155 tecken'
            forceRed={!!error}
            inputClassName="data-hj-allow"
            onChange={handleChange}
            multiline
            multilineRows={2}
            multilineMax={20}
            errorText={error}
          />
          <span
            style={{
              display: 'flex',
              justifyContent: 'right',
              color: error ? 'orangered' : 'black',
            }}
          >
            {`${getShortSalesDescriptionLength(
              state?.shortSalesDescription
            )}/${SHORT_SALES_DESCRIPTION_MAX_LENGTH} tecken`}
          </span>
          <AiFieldVerdict field="shortSalesDescription" />
        </div>
        {approve && state?.approve?.find(x => x.field === 'shortSalesDescription') && (
          <ThreeWaySwitch
            readOnly={readOnly}
            state={state}
            setState={setState}
            name="shortSalesDescription"
            style={{ marginBottom: 20 }}
          />
        )}
      </div>
    </div>
  );
};

export default ShortSalesDescription;
